import React from 'react'

export const Column33 = (props) => (
  <div className="fl w-100 w-third-ns pa3">{props.children}</div>
)

export const Column100 = (props) => (
    <div className="w-100 cf pa3">{props.children}</div>
)



// WEBPACK FOOTER //
// ./src/components/Column.js